export const ERROR_TYPES = {
  OPTIMISTIC_LOCKING: 'optimisticLocking',
  OTHER: 'other',
};
